module.exports = __webpack_public_path__ + "static/media/vegan.293ff268.png";